module.exports = __webpack_public_path__ + "images/your-band-is-a-virus.jpg?ded40";